/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * The scheduling policy to use for an application
 */
export enum SchedulingPolicy {
	MOON = "moon",
	GPU = "gpu",
	REGIONAL = "regional",
	FILL_METALS = "fill_metals",
	DEFAULT = "default",
}
